<template>
    <div class="MAM_brandInfo">
        <el-dialog
            :title="editBrand?'编辑终端类型':'添加终端类型'"
            width="50%"
            :visible="infoIsShow"
            :close-on-click-modal="false"
            @close="handleClose"
        >
            <el-form label-position="top" label-width="80px" :model="formList">
                <el-form-item label="终端类型名称：">
                    <el-input
                        size="medium"
                        v-model="formList.name"
                        placeholder="请输入终端类型名称"
                        maxlength="25"
                    ></el-input>
                </el-form-item>
                <el-form-item label="终端类型Logo：">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                    >
                        <div slot="tip" class="el-upload__tip">支持JPG、PNG格式，建议尺寸：118x118</div>
                        <img v-if="formList.path" :src="formList.path" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <!-- <el-form-item label="是否支持涨价：">
                    <el-radio v-model="formList.is_rise_price" :label="1">是</el-radio>
                    <el-radio v-model="formList.is_rise_price" :label="0">否</el-radio>
                </el-form-item> -->

                <el-form-item label="政策类型">
                    <el-radio v-for="item in brand_type_array" v-model="formList.brand_type" :label="item.value" :value="item.value" :disabled="editBrand">{{item.title}}</el-radio>
                </el-form-item>
                <el-form-item label="机具单价(元/台)：">
                    <el-input size="medium" v-model="formList.price" placeholder="请输入机具单价"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="handleClose">取 消</el-button> -->
                <el-button type="primary" @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_brandInfo",
    inject: ['reload'],
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        addBrand: {
            type: [String, Boolean]
        },
        editBrand: {
            type: [String, Boolean]
        },
        brandId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            uploadUrl: '',
            formList: {
                name: '',
                path: '',
                price: '',
                is_rise_price: 0,
                brand_type:1,
            },
            logoPath: '',
            brand_type_array:[
                {"value":1,"title":"1.0政策"},
                {"value":2,"title":"2.0政策"},
            ]
        };
    },
    mounted() {
        this.uploadUrl = this.$api.uploadUrl;//上传文件地址
        if (this.editBrand) {
            this.$api.post('brand/brand_detail', { brand_id: this.brandId }, res => {
                let { name, logo, price, path, is_rise_price ,brand_type} = res.data;
                this.formList.name = name;
                this.formList.path = logo;
                this.formList.price = price;
                this.formList.is_rise_price = is_rise_price;
				this.formList.brand_type = brand_type;
                this.logoPath = path;
            })
        }
    },
    methods: {
        submit() {
            let that = this;
            let reqData = this._.cloneDeep(this.formList); //析构
            reqData.path = this.logoPath;
            if (this.editBrand) {
                reqData.brand_id = this.brandId
            }
            this.$api.post('brand/add_or_update_brand', reqData, res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            // 刷新页面
                            that.handleClose(1);
                        }
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 2000,
                        onClose() {

                        }
                    })
                }
            })
        },
        handleClose(ref) { //关闭弹窗
            this.$emit('brandClose', ref);
        },
        handleAvatarSuccess(res) { //logo
            if (res.code === 0) {
                this.formList.path = res.data.file_url;
                this.logoPath = res.data.file_path;
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
        },
        beforeAvatarUpload() { //上传前的提示
            // const isJPG = file.type === 'image/jpeg';
            // const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            //     this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            // if (!isLt2M) {
            //     this.$message.error('上传头像图片大小不能超过 2MB!');
            // }
            // return isJPG && isLt2M;

        }
    }
};
</script>

<style scoped lang="scss">
.MAM_brandInfo {
    .el-input__inner {
        font-size: 12px;
    }

    .el-form-item {
        margin-bottom: 5px;
    }

    ::v-deep .el-form-item__label {
        font-size: 12px;
        font-weight: 700;
        padding: 0;
    }

    .avatar-uploader::v-deep .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader::v-deep .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon::v-deep {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar::v-deep {
        width: 178px;
        height: 178px;
        display: block;
    }
}
</style>